import { Controller } from "react-hook-form";
import { ImageUploader } from "@/components/ui";

const MediaStep = ({ control }) => {
    return (
        <Controller
            name="transaction_proof_image"
            control={control}
            render={({ field: { value, onChange } }) => (
                <ImageUploader
                    images={value || []}
                    onChange={onChange}
                    maxFiles={1}
                    label="Upload Bukti Transaksi"
                />
            )}
        />
    );
};

export default MediaStep;
